import BASE_URL from '../../config/env';
import {apiClient} from '../apiClient';
import {
  IAnalysisRequest,
  IBatchPrintSave,
  IExceptionFileTypesRequest,
} from '../types/documentPrinting.type';

const documentPrintingEndpoint = (path: string) =>
  `${BASE_URL}/documentprinting/api/v1/batchprint${path}`;

export const getSourceSelection = async () => {
  const {data} = await apiClient.get(
    documentPrintingEndpoint('/tree/source-selection')
  );
  return data;
};

export const getProductionSets = async () => {
  const {data} = await apiClient.get(
    documentPrintingEndpoint('/production/sets')
  );
  return data;
};

export const getProductionListBySetId = async (
  queryParams: number | string
) => {
  const {data} = await apiClient.get(
    documentPrintingEndpoint(
      `/production/by-set?productionSetId=${queryParams}`
    )
  );
  return data;
};
export const getAnalysis = async (payload: IAnalysisRequest) => {
  const {data} = await apiClient.post(
    documentPrintingEndpoint('/view/analysis'),
    payload
  );
  return data;
};

export const getFolders = async () => {
  const {data} = await apiClient.get(
    documentPrintingEndpoint('/folders')
  );
  return data;
};

export const getMetadataFields = async () => {
  const {data} = await apiClient.get(
    documentPrintingEndpoint('/metadata')
  );
  return data;
};

export const getFileSettings = async (isProductionPrint: boolean) => {
  const {data} = await apiClient.get(
    documentPrintingEndpoint(
      `/file-settings?isProductionPrint=${isProductionPrint}`
    )
  );
  return data;
};

export const getExceptionFileTypes = async (
  payload: IExceptionFileTypesRequest
) => {
  const {data} = await apiClient.post(
    documentPrintingEndpoint('/view/exceptionfiletypes'),
    payload
  );
  return data;
};
export const getSlipSheets = async () => {
  const {data} = await apiClient.get(
    documentPrintingEndpoint('/view/slipsheets')
  );
  return data;
};

export const batchPrintSave = async (payload: IBatchPrintSave) => {
  const {data} = await apiClient.post(
    documentPrintingEndpoint('/save'),
    payload
  );
  return data;
};
